import { requestPrices, requestRiskAmount } from '../../api/oncoCareApi';
import { ACTION_NAME, COUNTRIES } from '../../constants';
import { MONTHLY, PAYMENT_FREQUENCIES } from '../../constants/paymentFrequency';
import { getDiffInYearsFromNow } from '../../helpers/dates';
import { oncoCarePricePayloadSchema } from '../../validations/contract/oncoCare';

const SET_BIRTHDAY = 'efes/oncoCareCalculation/SET_BIRTHDAY';
const SET_PAYMENT_FREQUENCY = 'efes/oncoCareCalculation/SET_PAYMENT_FREQUENCY';
const SET_AGE = 'efes/oncoCareCalculation/SET_AGE';
const SET_WITH_CHILDREN = 'efes/oncoCareCalculation/SET_WITH_CHILDREN';
const SET_RISK_AMOUNT = 'efes/oncoCareCalculation/SET_RISK_AMOUNT';
const SET_RANGE = 'efes/oncoCareCalculation/SET_RANGE';

const GET_PRICE = 'efes/oncoCareCalculation/GET_PRICE';
const SET_PRICE = 'efes/oncoCareCalculation/SET_PRICE';
const GET_PRICE_SUCCESS = 'efes/oncoCareCalculation/GET_PRICE_SUCCESS';
const GET_PRICE_FAIL = 'efes/oncoCareCalculation/GET_PRICE_FAIL';

const GET_PRICES = 'efes/oncoCareCalculation/GET_PRICES';
const GET_PRICES_SUCCESS = 'efes/oncoCareCalculation/GET_PRICES_SUCCESS';
const GET_PRICES_FAIL = 'efes/oncoCareCalculation/GET_PRICES_FAIL';

const GET_RISK_AMOUNTS = 'efes/oncoCareCalculation/GET_RISK_AMOUNTS';
const GET_RISK_AMOUNTS_SUCCESS = 'efes/oncoCareCalculation/GET_RISK_AMOUNTS_SUCCESS';
const GET_RISK_AMOUNTS_FAIL = 'efes/oncoCareCalculation/GET_RISK_AMOUNTS_FAIL';

const CLEAR_CALCULATION = 'efes/oncoCareCalculation/CLEAR_CALCULATION';
const CLEAR_PRICES = 'efes/oncoCareCalculation/CLEAR_PRICES';

const initialState = {
  age: 0,
  withChildren: false,
  prices: {},
  paymentFrequencies: {},
  paymentFrequency: PAYMENT_FREQUENCIES[MONTHLY],
  isFetchingPrice: false,
  fetchPricesError: null,
  oncoCarePriceAmount: null,
  riskAmount: [],
  riskAmounts: [],
  isFetchingRiskAmounts: false,
  fetchRiskAmountsError: null,
  riskLabel: '',
  range: {},
};

export const setAge = (age, name) => ({
  type: SET_AGE,
  data: age,
  name,
});

export const setWithChildren = (withChildren, name) => ({
  type: SET_WITH_CHILDREN,
  data: withChildren,
  name,
});

export const setRiskAmount = (riskAmount, name) => ({
  type: SET_RISK_AMOUNT,
  data: riskAmount,
  name,
});

export const setRange = (range, name) => ({
  type: SET_RANGE,
  data: range,
  name,
});

export const clearPrices = (name) => ({
  type: CLEAR_PRICES,
  name,
});

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_RISK_AMOUNT:
      return {
        ...state,
        riskAmount: action.data,

      };
    case SET_WITH_CHILDREN:
      return {
        ...state,
        withChildren: action.data,
      };
    case SET_AGE:
      return {
        ...state,
        age: action.data,
      };
    case SET_PAYMENT_FREQUENCY:
      return {
        ...state,
        paymentFrequency: action.data,
      };
    case SET_RANGE:
      return {
        ...state,
        range: action.data,
      };
    case GET_PRICE:
      return {
        ...state,
        isFetchingPrice: true,
      };
    case SET_PRICE:
      return {
        ...state,
        oncoCarePriceAmount: action.result,
      };
    case GET_PRICE_SUCCESS:
      return {
        ...state,
        isFetchingPrice: false,
        oncoCarePriceAmount: action.result,
      };
    case GET_PRICE_FAIL:
      return {
        ...state,
        isFetchingPrice: false,
        priceError: action.error,
      };
    case GET_PRICES:
      return {
        ...state,
        isFetchingPrice: true,
      };
    case GET_PRICES_SUCCESS:
      return {
        ...state,
        isFetchingPrice: false,
        prices: action.result.price,
        paymentFrequencies: action.result.paymentFrequency,
        riskLabel: action.result.riskLabel,
      };
    case GET_PRICES_FAIL:
      return {
        ...state,
        isFetchingPrice: false,
        fetchPricesError: action.error,
      };
    case GET_RISK_AMOUNTS:
      return {
        ...state,
        isFetchingRiskAmounts: true,
      };
    case GET_RISK_AMOUNTS_SUCCESS:
      return {
        ...state,
        isFetchingRiskAmounts: false,
        riskAmounts: action.result.amounts,
        riskAmount: [action.result.defaultAmounts],
      };
    case GET_RISK_AMOUNTS_FAIL:
      return {
        ...state,
        isFetchingRiskAmounts: false,
        fetchRiskAmountsError: action.error,
      };
    case CLEAR_PRICES:
      return {
        ...state,
        prices: {},
      };
    case CLEAR_CALCULATION:
      return initialState;
    default:
      return state;
  }
}

const createReducerWithName = (name) => (state = initialState, action) => {
  if (action.name !== name) {
    return state;
  }
  return reducer(state, action);
};

export const oncoCareCalculationReducerForContract = createReducerWithName(
  'contract',
);

export const setBirthday = (birthday, name) => ({
  type: SET_BIRTHDAY,
  data: birthday,
  name,
});

export const setPaymentFrequency = (data, name) => ({
  type: SET_PAYMENT_FREQUENCY,
  data,
  name,
});

export const clearCalculation = (name) => ({
  type: CLEAR_CALCULATION,
  name,
});

export const setPrice = (data) => (dispatch) => {
  dispatch({
    type: SET_PRICE,
    result: data,
  });
};

export const getPrices = (data, name) => (dispatch) => {
  const {
    insuredPeople,
    age,
    withChildren,
    riskAmount,
  } = data;

  let people;

  if (name === ACTION_NAME.CONTRACT) {
    people = insuredPeople && !!insuredPeople.length
      && insuredPeople.map((insuredPerson) => ({
        passport: insuredPerson.passport,
        age: getDiffInYearsFromNow(insuredPerson.birthday),
        riskAmount: riskAmount[0],
        citizenship: insuredPerson.citizenship,
        isPerson: insuredPerson.isPerson,
        isParent: insuredPerson.isParent,
        isChild: insuredPerson.isChild,
      }));

    if (!people || !people.length) {
      return;
    }

    const hasChild = people.some((person) => person.isChild);

    if (hasChild) {
      // If any insured person is a child, set the first person as the parent
      people[0].isParent = true;
      people[0].isPerson = false;
      people[0].isChild = false;
    } else {
      // If no insured person is a child, set the first person as just a person
      people[0].isParent = false;
      people[0].isPerson = true;
      people[0].isChild = false;
    }
  } else {
    if (!age) {
      return;
    }
    people = [{
      age,
      citizenship: COUNTRIES.ARM,
      riskAmount: riskAmount[0],
      isPerson: !withChildren,
      isParent: withChildren,
      isChild: false,
    }];
  }

  const payload = {
    insuredPeople: people,
  };

  oncoCarePricePayloadSchema.isValid(payload).then((isValid) => {
    if (isValid) {
      dispatch({
        actions: [
          { type: GET_PRICES, name },
          { type: GET_PRICES_SUCCESS, name },
          {
            type: GET_PRICES_FAIL,
            name,
            showError: true,
            customMsg: 'getPricesFail',
          },
        ],
        promise: requestPrices(payload),
      });
    }
  });
};

export const getRiskAmounts = (name) => (dispatch) => {
  dispatch({
    actions: [
      { type: GET_RISK_AMOUNTS, name },
      { type: GET_RISK_AMOUNTS_SUCCESS, name },
      {
        type: GET_RISK_AMOUNTS_FAIL,
        name,
        showError: true,
      },
    ],
    promise: requestRiskAmount(),
  });
};
